export default __webpack_public_path__ + "static/media/logoMark.5b0e8d48.svg";